import { Clock } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { CTAButtons } from "@/components/CTAButtons";
import { TIMINGS, VISITING_BG } from "@/data/clinic";

const CHIPS = ["Walk-ins welcome", "First-come, first-served", "Call before visiting"];

export const Visiting = () => (
  <section data-testid="visiting-section" className="relative overflow-hidden bg-[#063A2F] py-24 lg:py-28">
    <div className="absolute inset-0" aria-hidden="true">
      <img
        src={VISITING_BG}
        alt=""
        loading="lazy"
        decoding="async"
        className="h-full w-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#063A2F]/80 via-[#063A2F]/70 to-[#063A2F]/90" />
    </div>
    <div className="relative mx-auto max-w-5xl px-6 lg:px-10">
      <Reveal>
        <Eyebrow dark>Visiting Information</Eyebrow>
        <div className="mt-8 flex items-start gap-6">
          <Clock className="mt-2 hidden h-10 w-10 shrink-0 text-[#D4AF37] sm:block" strokeWidth={1.5} />
          <p
            data-testid="visiting-message"
            className="font-display text-2xl leading-snug text-[#FDFCF8] sm:text-3xl lg:text-4xl"
          >
            “Patients are attended on a first-come, first-served basis. Treatment
            duration may vary depending on the dental procedure. Please call or
            WhatsApp the clinic before visiting for current availability.”
          </p>
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          {CHIPS.map((c) => (
            <span
              key={c}
              className="rounded-full border border-[#D4AF37]/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#D4AF37]"
            >
              {c}
            </span>
          ))}
        </div>

        <div
          className="mt-10 grid gap-x-12 gap-y-3 border-t border-white/10 pt-8 sm:grid-cols-2"
          data-testid="visiting-timings"
        >
          {TIMINGS.map((t) => (
            <div
              key={t.day}
              className="flex flex-col gap-y-0.5 sm:flex-row sm:items-baseline sm:justify-between sm:gap-x-4"
            >
              <span className="text-sm font-semibold text-[#FDFCF8]">{t.day}</span>
              {t.closed ? (
                <span className="text-sm font-bold text-[#D4AF37]">By Appointment Only</span>
              ) : (
                <span className="text-sm text-[#F2FBF7]/70">{t.hours.join("  ·  ")}</span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10">
          <CTAButtons dark />
        </div>
      </Reveal>
    </div>
  </section>
);
